/**
 * 课程评价列表功能
 * @Author:wuTao
 * @Date 2021/04/02
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './config';

import {component_tool, framework_tool, utils_tool} from '@/tool'
import {WizModalUserIdentityShow} from '@/containers/common';

let {checkStrLength, Session} = utils_tool;
let {WizSpin, WizBrowserExport, WizModal} = component_tool;
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;


const getProgramEvaluation = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/program/programList/programEvaluation') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('programEvaluationInfo', record)
      } else {
        record = Session.get('programEvaluationInfo') || 0
      }
    }
  } else {
    record = Session.get('programEvaluationInfo') || 0
  }
  return record
}

class ProgramEvaluation extends WizContainer {

  componentName = 'programEvaluation';

  constructor(props) {
    super(props);
    const {history} = props;
    this.state = {
      studentProgramEvaluationRecord: {},
      showUserPersonInfoVisible: false,
      selectedStudentProgramEvaluationRows: [],//选择的学员评语
      selectedRows: 0
    };
    this.initialValue = getProgramEvaluation(props.history);
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleStudentProgramEvaluation(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _render() {
    //初始化路径评语ID
    const {showUserPersonInfoVisible, studentProgramEvaluationRecord} = this.state;
    let initialValue = this.initialValue;
    const {id} = initialValue;
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedStudentProgramEvaluationRows: rows,
          selectedRows: rows.length
        });
      },
      _this: this,
      programId: id,
      _btnLookUserFun: (e) => {
        if (e.record) {
          this.setState({
            studentProgramEvaluationRecord: e.record,
            showUserPersonInfoVisible: true,
          })
        }
      },
      _btnLookProgramEvaluationFun: (e) => {
        if (e.record) {
          this.setState({
            studentProgramEvaluationRecord: e.record,
          })
        }
      }
    });
    let _reduxTemplateConfig = reduxTemplateConfig({
      programId: id,
      templateConfig: _templateConfig,
      apiDataFormat: {},
    });
    let lookUserPersonInfoModal = {
      title: '查看任职',
      visible: showUserPersonInfoVisible,
      personId: studentProgramEvaluationRecord.commentPerson ? studentProgramEvaluationRecord.commentPerson : null,
      orgId: null,
      positionId: null,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          studentProgramEvaluationRecord: {},
        });
      },
    };
    return (
      <>
        <WizReduxTemplate {..._reduxTemplateConfig} />
        <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>
      </>)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ProgramEvaluation);
